<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
import { ref } from 'vue';
import { useStorageStore } from '@/stores/storage';

const props = defineProps({
    storage: {
        type: Object,
        required: true
    },
    mode: {
        type: String,
        default: 'Create'
    }
});

const emit = defineEmits(['close-modal', 'cancel-modal']);

const form = ref({
    rows: 1,
    racks: 1,
    levels: 1,
    capacity: 4,
    append: props.storage.bins_count > 0,
});

const { generateBins } = useStorageStore();

const save = async () => {
    try {
        await generateBins({
            ...form.value,
            hash: props.storage.hash,
        });

        emit('close-modal');
    } catch (error) {
        // The response interceptor surfaces the error toast
    }
};
</script>
<template>
<ModalWrapper @cancel-modal="emit('cancel-modal')">
    <template #header>{{ $t('label.generate_bins') }}</template>
    <template #subheader>{{ storage.name }}</template>

    <form @submit.prevent="save">
        <div class="grid md:grid-cols-2 gap-x-4 gap-y-3">
            <StyledInput
                v-model.number="form.rows"
                name="rows"
                type="number"
                :placeholder="$t('label.rows')"
                :label="$t('label.rows')" />
            <StyledInput
                v-model.number="form.racks"
                name="racks"
                type="number"
                :placeholder="$t('label.racks')"
                :label="$t('label.racks')" />
            <StyledInput
                v-model.number="form.levels"
                name="levels"
                type="number"
                :placeholder="$t('label.levels')"
                :label="$t('label.levels')" />
            <StyledInput
                v-model.number="form.capacity"
                name="capacity"
                type="number"
                :placeholder="$t('label.capacity')"
                :label="$t('label.capacity')" />
        </div>
        <p class="text-xs text-ink-light">{{ $t('label.bin_capacity_hint') }}</p>

        <StyledRoundSwitch
            v-model="form.append"
            :label="$t('label.append_to_existing')"
            inset
            class="mt-2"
            name="append" />
    </form>

    <template #footer>
        <StyledSaveButton modal @save="save" />
    </template>
</ModalWrapper>
</template>
